import Home from '@/views/Home/Home'
import Help from '@/views/Help/Help'
// 产品技术
import Product from '@/views/Product/Product'
import SuperiorProducts from '@/views/Product/SuperiorProducts'
import EasyChange from '@/views/Product/EasyChange'
import SafetyRecovery from '@/views/Product/SafetyRecovery'
import IntelligentRecovery from '@/views/Product/IntelligentRecovery'
import TianJiHui from '@/views/Product/TianJiHui'

// 解决方案
import Solution from '@/views/Solution/Solution'
import Service from '@/views/Solution/Service'
import BSolution from '@/views/Solution/BSolution'
import SupplyChain from '@/views/Solution/SupplyChain'

// 开放平台
import OpenPlatform from '@/views/OpenPlatform/OpenPlatform'

export default [{
        path: '/home',
        component: Home
    },
    {
        path: '/product',
        component: Product,
        children: [{
                path: '/product/superiorProducts',
                component: SuperiorProducts
            },
            {
                path: '/product/easyChange',
                component: EasyChange
            },
            {
                path: '/product/safetyRecovery',
                component: SafetyRecovery
            },
            {
                path: '/product/intelligentRecovery',
                component: IntelligentRecovery
            },
            {
                path: '/product/tianJiHui',
                component: TianJiHui
            },
            //重定向 Easy to change
            {
                path: '/product',
                redirect: '/product/superiorProducts'
            }
        ]
    },
    {
        path: '/solution',
        component: Solution,
        children: [{
                path: '/solution/service',
                component: Service
            },
            {
                path: '/solution/bsolution',
                component: BSolution
            },
            {
                path: '/solution/supplychain',
                component: SupplyChain
            },
            //重定向 service
            {
                path: '/solution',
                redirect: '/solution/service'
            }
        ]
    },
    {
        path: '/openPlatform',
        component: OpenPlatform,
    },
    {
        path: '/help',
        component: Help
    },
    // 重定向
    {
        path: '/',
        redirect: '/home'
    }
]